import { indexOf } from './board.js';
import { nextInt } from './rng.js';
const ATTEMPTS_PER_VIRUS = 500;
/** Длина ряда одного цвета через (x, y) вдоль направления (dx, dy), если поставить туда color. */
export function runLength(cells, board, x, y, color, dx, dy) {
    const sameColor = (cx, cy) => {
        if (cx < 0 || cy < 0 || cx >= board.width || cy >= board.height) {
            return false;
        }
        const cell = cells[indexOf(board, cx, cy)];
        return (cell?.kind === 'virus' || cell?.kind === 'segment') && cell.color === color;
    };
    let length = 1;
    for (let i = 1; sameColor(x + dx * i, y + dy * i); i++)
        length++;
    for (let i = 1; sameColor(x - dx * i, y - dy * i); i++)
        length++;
    return length;
}
/**
 * Расставляет вирусы в строках virusTopRow … height − 1 так, чтобы не было рядов из
 * (matchLength − 1) и более вирусов одного цвета: на старте нет готовых и почти готовых совпадений.
 * Клетка и стартовый цвет выбираются случайно, затем цвета перебираются по кругу.
 */
export function placeViruses(board, rules, rngState) {
    const cells = board.cells.slice();
    const maxRun = rules.matchLength - 2;
    const zoneHeight = rules.height - rules.virusTopRow;
    let state = rngState;
    let placed = 0;
    let attempts = 0;
    while (placed < rules.virusCount) {
        if (attempts++ > rules.virusCount * ATTEMPTS_PER_VIRUS) {
            throw new RangeError(`cannot place ${rules.virusCount} viruses with the given rules`);
        }
        const rx = nextInt(state, rules.width);
        const ry = nextInt(rx.state, zoneHeight);
        const rc = nextInt(ry.state, rules.colorCount);
        state = rc.state;
        const x = rx.value;
        const y = rules.virusTopRow + ry.value;
        if (cells[indexOf(board, x, y)]?.kind !== 'empty') {
            continue;
        }
        for (let k = 0; k < rules.colorCount; k++) {
            const color = (rc.value + k) % rules.colorCount;
            if (runLength(cells, board, x, y, color, 1, 0) <= maxRun &&
                runLength(cells, board, x, y, color, 0, 1) <= maxRun) {
                cells[indexOf(board, x, y)] = { kind: 'virus', color };
                placed++;
                break;
            }
        }
    }
    // «Биоплёнка»: случайные стартовые вирусы (частичное перемешивание, без повторов).
    const virusIndices = cells.flatMap((c, i) => (c.kind === 'virus' ? [i] : []));
    for (let k = 0; k < rules.biofilmCount && k < virusIndices.length; k++) {
        const pick = nextInt(state, virusIndices.length - k);
        state = pick.state;
        const j = k + pick.value;
        const chosen = virusIndices[j] ?? 0;
        virusIndices[j] = virusIndices[k] ?? 0;
        virusIndices[k] = chosen;
        const virus = cells[chosen];
        if (virus?.kind === 'virus') {
            cells[chosen] = { kind: 'virus', color: virus.color, shield: true };
        }
    }
    return { board: { ...board, cells }, state };
}
//# sourceMappingURL=virus-placement.js.map